module.exports = __webpack_public_path__ + "img/16-small.89bb637b.png";